import React from 'react';

const shapes = {
  burger: <><path d="M4 10a8 7 0 0 1 16 0H4Z" /><path d="M8 7h1m6 0h1M3 13l3 1 3-1 3 1 3-1 3 1 3-1M4 17h16v1a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1Z" /></>,
  menu: <><path d="M2 21h20M3 17h11M4 14a4.5 4.5 0 0 1 9 0H4ZM4 20h9M17 9h5l-1 12h-3L17 9Zm2 0 1-6h3M5 8V3m3 4V2m3 6V3" /></>,
  basket: <><path d="m8 3-4 7m12-7 4 7M2 10h20l-2 11H4L2 10Zm6 4v3m4-3v3m4-3v3" /></>,
  payment: <><rect x="2" y="4" width="20" height="16" rx="3" /><path d="M2 10h20M6 15h4m6 0h2" /></>,
  guest: <><circle cx="14" cy="4" r="2" /><path d="m5 12 4-4 4 1 3 4 3 1M13 9l-2 6-4 6m4-6 4 6M7 8l3-1" /></>,
};

export default function OrgasmeatActionIcon({ name }) {
  return shapes[name] ? <svg className="orgasmeat-action-icon" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{shapes[name]}</svg> : null;
}
